module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-59e3e9d19e6de4485cfcd7568dbc8ab2.png";